import { motion } from "framer-motion";
import { Shield, Zap, Award, Wrench, Factory, Palette, HeartHandshake, BadgeCheck } from "lucide-react";

const guarantees = [
  { icon: Factory, title: "Fabrication Française", desc: "Conception et fabrication dans nos ateliers en Île-de-France" },
  { icon: Shield, title: "Garantie Décennale", desc: "Tous nos travaux sont couverts par une garantie décennale" },
  { icon: Wrench, title: "Installation Pro", desc: "Pose par nos équipes qualifiées, nacelle incluse" },
  { icon: Zap, title: "LED Haute Qualité", desc: "LEDs Samsung/Osram, durée de vie 50 000 heures" },
  { icon: Palette, title: "Sur Mesure", desc: "Chaque enseigne est unique, conçue selon votre identité" },
  { icon: Award, title: "Rapport Qualité/Prix", desc: "Les meilleurs tarifs du marché, sans compromis" },
  { icon: HeartHandshake, title: "Accompagnement", desc: "De la conception à la pose, un interlocuteur dédié" },
  { icon: BadgeCheck, title: "Conformité", desc: "Respect des normes en vigueur et déclaration en mairie" },
];

export function ReassuranceSection() {
  return (
    <section className="py-24 sm:py-32 px-4 sm:px-6 lg:px-8 bg-[#050505]" data-testid="reassurance-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm uppercase tracking-[0.3em] font-medium text-[#00FF66] mb-4 font-['Outfit',sans-serif]">NOS GARANTIES</p>
          <h2 className="font-['Clash_Display',sans-serif] text-3xl sm:text-4xl font-semibold tracking-tight text-white">
            Pourquoi choisir PUB PRO
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {guarantees.map((item, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: idx * 0.05, duration: 0.5 }}
              className="bg-[#121212] border border-[#262626] rounded-2xl p-6 text-center hover:border-[#00FF66]/30 hover:shadow-[0_0_20px_rgba(0,255,102,0.08)] transition-all duration-300"
              data-testid={`guarantee-${idx}`}
            >
              <div className="w-12 h-12 mx-auto rounded-xl bg-[#00FF66]/10 flex items-center justify-center mb-4">
                <item.icon className="w-6 h-6 text-[#00FF66]" />
              </div>
              <h3 className="text-white font-semibold text-sm font-['Outfit',sans-serif] mb-2">{item.title}</h3>
              <p className="text-zinc-500 text-xs leading-relaxed">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
